import { makeStyles } from '@material-ui/core/styles';
import { Theme } from 'enum';

export const useStyle = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    logoContainer: {
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        backgroundColor: '#fff',
        boxShadow: `${theme.palette.type === Theme.Light ? '0 0 16px #eee' : '0 0 16px #111'}`,
        margin: theme.spacing(4),
        marginTop: 0,
        [theme.breakpoints.down('xs')]: {
            marginBottom: theme.spacing(3),
            width: '80px',
            height: '80px',
        },
    },
    logo: {
        width: '100%',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
    },
    inputIcon: {
        color: 'grey',
    },
    submit: {
        fontSize: '15px',
        marginTop: theme.spacing(2),
        padding: theme.spacing(1.7),
    },
    container: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.paper,
    },
    heading: {
        fontWeight: 'bold',
        display: 'block',
        textAlign: 'center',
        color: `${theme.palette.type === Theme.Light ? '#333' : '#fff'}`,
    },
    toggleButtonGroup: {
        width: '100%',
        padding: 0,
        margin: 0,
        '& .Mui-selected': {
            backgroundColor: '#47bb67',
            color: '#fff',
            border: 'none',
            '&:hover': {
                backgroundColor: '#47bb67',
                color: '#fff',
            },
        },
    },
    toggleButton: {
        transition: '0.3s',
        width: '100%',
        border: 'none',
        color: `${theme.palette.type === Theme.Light ? '#888' : '#eee'}`,
        backgroundColor: `${theme.palette.type === Theme.Light ? '#f2f2f2' : 'transparent'}`,
        '&:hover': {
            backgroundColor: `${theme.palette.type === Theme.Light ? '#e4f6e9' : '#373737'}`,
            color: `${theme.palette.type === Theme.Light ? '#289c41' : '#47bb67'}`,
        },
    },
    toggleButtonIcon: {
        marginRight: '10px',
    },
}));
